<template>
	<c-dialog ref="dialog" title="会员库" width="900" @resolve="resolve">
		<m-search ref="search" @search="search">
			<c-form ref="form" inline>
         <c-form-item type="input" label="手机号" name="user_manage_mobilephone"></c-form-item>
<!--        <c-form-item type="input" label="用户名" name="login_name"></c-form-item>-->
		<c-form-item type="input" label="昵称" name="nick_name"></c-form-item>
        <c-form-item type="select" label="等级" name="user_level" options="USER_LEVEL_AUTH"></c-form-item>
      </c-form>
		</m-search>
			
		<c-table ref="table" height="400">
			<c-table-column
				type="selector"
        :multiple="!!multiple"
			></c-table-column>

      <c-table-column label="状态" name="state"  width="40">
        <template v-slot="{data}">
          <span v-if="data.state == 1" style="color:green">启用</span>
          <span v-if="data.state == 2" style="color:red">禁用</span>
        </template>
      </c-table-column>

      <c-table-column
          label="手机号"
          name="user_manage_mobilephone"
          width="100"
      >
        <template v-slot="{data}">
          <span v-if="data.user_manage_mobilephone && data.user_manage_mobilephone!=''">{{data.user_manage_mobilephone}}</span>
          <span v-else>--</span>
        </template>
      </c-table-column>


			<!-- <c-table-column
				label="用户名"
				name="login_name"
        width="100"
      >
        <template v-slot="{data}">
          <span v-if="data.login_name && data.login_name!=''">{{data.login_name}}</span>
          <span v-else>--</span>
        </template>
      </c-table-column> -->

			<c-table-column
				label="昵称"
				name="nick_name"
        width="120"
      >
        <template v-slot="{data}">
          <span v-if="data.nick_name && data.nick_name!=''">{{data.nick_name}}</span>
          <span v-else>--</span>
        </template>
      </c-table-column>

      <c-table-column
          label="等级"
          name="user_level_name"
      >
        <template v-slot="{data}">
          <span v-if="data.user_level_name && data.user_level_name!='' && data.user_level!=0" style="color:blue">{{data.user_level_name}}</span>
          <span v-else>普通用户</span>
        </template>
      </c-table-column>

			<c-table-column
				label="注册时间"
				name="create_date"
      >
      </c-table-column>
		</c-table>
	</c-dialog>
</template>

<script>
	export default {
		props: {
			multiple: Boolean
		},
		methods: {
			search(data) {
				this.$refs.table.load({
					url: '/platform_user/list',
					data
				});
			},
			
			open() {
				this.$refs.form.clear();
				this.$refs.search.search();
				this.$refs.dialog.open();
			},
			
			resolve(stop) {
				var data = this.$refs.table.getRow('selected');
				if (!data.length) {
					stop();
					this.$message({
						text: '请选择会员'
					});
					return;
				}
				this.$emit('resolve', Array.from(data, item => item.data));
			}
		}
	}
</script>